
    var riot = require('riot')
    riot.tag2('gb-record-zone', '<gb-list items="{$zone.records}"> <gb-product all_meta="{item.allMeta}"></gb-product> </gb-list>', '', '', function(opts) {
});

    
  


// WEBPACK FOOTER //
// ./src/tags/template/gb-record-zone.tag.html